import { Card } from "../../components/Card";
import { MORE_SPORTS } from "../../content/landing";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from "../../content/ticker";
import styles from "./MoreSports.module.css";

/**
 * The grid's last cell, and the only one that is not a model.
 *
 * ── WHY IT IS NOT A ModelCard ────────────────────────────────────────────────
 * It would have been half the code to fake a catalogue entry with
 * `build: "soon"` and let ModelCard render it. That is exactly what must not
 * happen: `catalogue.test.ts` and the invariant at the top of config/catalogue.ts
 * exist to stop anything appearing in this grid that is not a real model, and a
 * "Coming soon" badge on a ninth tile would read as a ninth product we have not
 * named. So this is its own component, with no badge, no persona line and no
 * "Not yet available" footer — none of which it is entitled to.
 *
 * It is a static panel, never a link: `Card` gets no `to`. The only thing to
 * click is the Instagram link inside it, and making the whole cell navigate
 * somewhere would put an outbound link where every neighbour opens a model.
 */
export function MoreSports() {
  return (
    <Card className={styles.card}>
      <div className={styles.labels}>
        <span className={styles.label}>{MORE_SPORTS.label}</span>
        <span className={styles.heading}>{MORE_SPORTS.heading}</span>
      </div>
      <p className={styles.cta}>
        {MORE_SPORTS.ctaLead}{" "}
        {/* rel="noopener noreferrer" for the reason Ticker.tsx already does it:
            target="_blank" hands the new tab a reference back to this one. */}
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
          {INSTAGRAM_HANDLE}
        </a>{" "}
        {MORE_SPORTS.ctaTail}
      </p>
    </Card>
  );
}
